import '@mockup/func/globals/App.util';
import { App } from './App';

export const fileUploader = {
    init: function () {
        if (document.querySelector('.js-file-upload')) import('@mockup/func/fileupload/index').then(module => module.default.init());
    }
};

export default fileUploader;

App.Util.fileUploader = fileUploader;
